'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerMenuComponent = exports.sellerMenuComponent = {
    template: require('./menu.html'),
    bindings: {
        seller: '<',
        sellerModules: '<',
        numberOfContracts: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$element", function controller(common, $element) {
        'ngInject';

        var vm = this;
        vm.sellerNavIsOpen = false;
        vm.toggleSellerNav = toggleSellerNav;
        vm.hideSellerNav = hideSellerNav;
        vm.moduleEnabled = moduleEnabled;
        vm.isNotFebelcoPartner = true;
        vm.$onInit = init;
        function init() {
            $element.on('click', 'a:not(.site-seller-header-toggle)', function () {
                vm.hideSellerNav();
            });
            vm.isNotFebelcoPartner = vm.seller.code !== 'FPA';
        }

        function toggleSellerNav() {
            vm.sellerNavIsOpen = !vm.sellerNavIsOpen;
        }

        function hideSellerNav() {
            vm.sellerNavIsOpen = false;
        }

        function moduleEnabled(module) {
            // Dirty, dirty hack for Febelco Partner!
            if (module === 'PRODUCT' && vm.seller && vm.seller.img && vm.seller.img.indexOf('FPA') === 0) {
                return false;
            }
            return (vm.sellerModules || []).indexOf(module) >= 0;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/components/menu.js
// module id = 1011
// module chunks = 0